import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { FaArrowLeft } from 'react-icons/fa';

const products = [
  {
    id: 1,
    name: 'Fender Stratocaster',
    brand: 'Fender',
    price: '$1,199',
    image: 'https://cartervintage.com/sized-images/2BA6HRjgtWtExGwfsgBD6nYtxhV/2HaTw3hOU7SviyhRNVMRGJhOMOm/product.jpeg',
    description: 'A classic guitar loved by musicians all around the world.',
  },
  {
    id: 2,
    name: 'Gibson Les Paul',
    brand: 'Gibson',
    price: '$2,499',
    image: 'https://cartervintage.com/sized-images/2BA6HRjgtWtExGwfsgBD6nYtxhV/2ZY2CWEW8oJmj58QYhEI9s7lmvq/product.jpeg',
    description: 'A powerful guitar known for its rich tone and sustain.',
  },
  {
    id: 3,
    name: 'Gibson SG Special 1961',
    brand: 'Gibson',
    price: '$9,200',
    image: 'https://cartervintage.com/sized-images/2BA6HRjgtWtExGwfsgBD6nYtxhV/2h6SLVFD0O2655Ofx6ABic9AnAP/product.jpeg',
    description: 'A modern guitar favored by rock and metal guitarists.',
  },
  // Add more products as needed
];

const ProductDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const product = products.find(p => p.id === parseInt(id as string));

  if (!product) {
    return <div>Product not found</div>;
  }

  return (
    <div className="min-h-screen bg-gray-100 p-6">
      <button
        onClick={() => navigate(-1)}
        className="text-blue-600 flex items-center mb-4"
      >
        <FaArrowLeft className="mr-2" />
        Back
      </button>
      <div className="bg-white p-6 rounded-lg shadow-md">
        <img src={product.image} alt={product.name} className="w-full h-64 object-cover rounded-t-lg" />
        <div className="mt-4">
          <h2 className="text-2xl font-semibold">{product.name}</h2>
          <p className="text-gray-600">{product.brand}</p>
          <p className="text-gray-800 mt-2">{product.price}</p>
          <p className="text-gray-700 mt-4">{product.description}</p>
        </div>
      </div>
    </div>
  );
};

export default ProductDetail;
